import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import _ from "lodash";

import { Table } from "../../../../../components/table/Table";
import { Mobile, NotMobile } from "../../../../../hocs/Responsive";
import { useIntlTranslate } from "../../../../../hooks";
import { NoDevices } from "../../noDevices/NoDevices";
import {
  COLUMNS,
  COLUMNS_MOBILE,
  SEARCH_KEYS,
} from "./ProfileNotRoamingDevicesTable.consts";
import { ProfileNotRoamingDevicesTableHeader } from "./components";
import { getNotRoamingDevicesByProfile } from "../../../../../store/devices/logicalDevices";

export const ProfileNotRoamingDevicesTable = ({ profileName, profileId }) => {
  const devices = useSelector(
    getNotRoamingDevicesByProfile(profileName),
    _.isEqual
  );
  const hasDevices = devices.length !== 0;
  const translate = useIntlTranslate();
  const caption = translate("unassigned");

  if (!hasDevices) {
    return <NoDevices profileName={profileName} />;
  }

  return (
    <Fragment>
      <Mobile>
        <Table
          header={<ProfileNotRoamingDevicesTableHeader profileId={profileId} />}
          searchKeys={SEARCH_KEYS}
          showPagination
          visibleHeader={false}
          columns={COLUMNS_MOBILE}
          hiddenColumns={["identifiers"]}
          data={devices}
          searchAriaLabelMessage="aria_search_for_device"
          caption={caption}
        />
      </Mobile>
      <NotMobile>
        <Table
          header={<ProfileNotRoamingDevicesTableHeader profileId={profileId} />}
          searchKeys={SEARCH_KEYS}
          showPagination
          columns={COLUMNS}
          data={devices}
          searchAriaLabelMessage="aria_search_for_device"
          caption={caption}
        />
      </NotMobile>
    </Fragment>
  );
};
